// 시간 입력 헬퍼 — 모바일 숫자 키패드에는 ':'가 없으므로 숫자만 쳐도 HH:mm이 되게 한다.
//
// formatTimeTyping: 타이핑 중 실시간 — "0959" → "09:59" (4자리에서 자동 콜론).
//   데스크탑에서 콜론을 직접 치면 그대로 존중(자릿수만 정리).
// finalizeTime: blur/저장 직전 최종 정규화 — "930" → "09:30", "9" → "09:00".
//   (출퇴근 달력의 기존 autoFormatTime과 동일 규칙 — 관례 유지)

export function formatTimeTyping(value) {
  const raw = String(value || '');
  if (raw.includes(':')) {
    const [h = '', m = ''] = raw.split(':');
    const hh = h.replace(/\D/g, '').slice(0, 2);
    const mm = m.replace(/\D/g, '').slice(0, 2);
    return `${hh}:${mm}`;
  }
  const d = raw.replace(/\D/g, '').slice(0, 4);
  if (d.length <= 2) return d;
  return `${d.slice(0, 2)}:${d.slice(2)}`;
}

export function finalizeTime(value) {
  const raw = String(value || '');
  // 콜론이 있으면 시/분을 각각 정규화 ("9:5" → "09:05") — 전체 숫자 이어붙이기 금지("09:5"→"00:95" 방지)
  if (raw.includes(':')) {
    const [h = '', m = ''] = raw.split(':');
    const hh = h.replace(/\D/g, '').slice(0, 2);
    const mm = m.replace(/\D/g, '').slice(0, 2);
    if (!hh && !mm) return '';
    return `${hh.padStart(2, '0')}:${mm.padStart(2, '0')}`;
  }
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length <= 2) return `${digits.padStart(2, '0')}:00`;
  if (digits.length === 3) return `0${digits[0]}:${digits.slice(1)}`;
  return `${digits.slice(0, 2)}:${digits.slice(2, 4)}`;
}
